import { Component, OnInit, Input } from "@angular/core";
import { OpSitesService } from "../../../common/services/op-sites.service";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import {
  HttpClientJsonpModule,
  HttpClientModule,
  HttpClient,
} from "@angular/common/http";
import { ManageNewsLettersService } from "src/app/views/common/services/manage-news-letters.service";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-op-newsletter-dialog",
  templateUrl: "./op-newsletter-dialog.component.html",
  styleUrls: ["./op-newsletter-dialog.component.css"],
})
export class OpNewsletterDialogComponent implements OnInit {
  sites: any;
  flag: any;
  email: any;
  newsLertterDialog: FormGroup;
  single: Boolean = true;
  multiple: Boolean = false;
  all: Boolean = false;
  isSubmitted = false;
  @Input() title: string;
  @Input() message: string;
  @Input() newsletterId: string;
  @Input() btnOkText: string;
  @Input() btnCancelText: string;

  constructor(
    private siteServ: OpSitesService,
    private newsletterServ: ManageNewsLettersService,
    private activeModal: NgbActiveModal,
    private http: HttpClient,
    private toastr: ToastrService
  ) {}

  buildTemplateDialogForm() {
    this.newsLertterDialog = new FormGroup({
      single: new FormControl("", Validators.required),
      multi: new FormControl("", Validators.required),
      all: new FormControl("", Validators.required),
      site_id: new FormControl(""),
      email: new FormControl(""),
    });
  }

  ngOnInit() {
    this.buildTemplateDialogForm();
    this.getAllSites();
    this.flag = 0;
    this.onSingle();
  }
  onSubmit(formValues) {
    if (formValues.site_id == "" && formValues.email == "") {
      this.isSubmitted = true;
      this.newsletterServ.sendAllSite(this.newsletterId).subscribe((res) => {
        this.toastr.success("Send All Site successfully", "", {
          positionClass: "toast-top-center",
        });
        this.activeModal.dismiss();
      });
      (err: any) => {
        if (err.status == 302) {
          this.toastr.error(err.error.message, "Site", {
            positionClass: "toast-top-center",
          });
        } else {
          console.error(err);
        }
      };
    } else if (formValues.site_id == "") {
      this.isSubmitted = true;
      this.newsletterServ
        .specificCusmermail(this.newsletterId, formValues.email)
        .subscribe((res) => {
          this.toastr.success("Specific Customer Send successfully", "", {
            positionClass: "toast-top-center",
          });
          this.activeModal.dismiss();
        });
      (err: any) => {
        if (err.status == 302) {
          this.toastr.error(err.error.message, "Site", {
            positionClass: "toast-top-center",
          });
        } else {
          console.error(err);
        }
      };
    } else {
      this.newsletterServ.specificCusmermSite(formValues.site_id).subscribe(
        (res) => {
          this.isSubmitted = true;
          this.toastr.success("Specific Site Send successfully", "", {
            positionClass: "toast-top-center",
          });
          this.newsLertterDialog.reset();
          this.activeModal.dismiss();
        },
        (err: any) => console.error(err)
      );
    }
    this.activeModal.dismiss();
    (err: any) => {
      if (err.status == 302) {
        this.toastr.error(err.error.message, "Site", {
          positionClass: "toast-top-center",
        });
      } else {
        console.error(err);
      }
    };
  }
  prepareFormDataBody(formValues) {
    return formValues;
  }
  onSingle() {
    this.single = true;
    this.multiple = false;
    this.all = false;
  }
  onMultiple() {
    this.single = false;
    this.multiple = true;
    this.all = false;
  }
  onAll() {
    this.single = false;
    this.multiple = false;
    this.all = true;
  }
  getAllSites() {
    this.siteServ.getAllSite().subscribe((res: any) => {
      this.sites = res.data;
    });
  }
  public decline() {
    this.activeModal.close(false);
  }
  public accept() {
    this.activeModal.close(this.email);
  }
  public dismiss() {
    this.activeModal.dismiss();
  }
}
